import { VehicleValuationProvider } from "@/api-schema-enums";
import { VEHICLE_VALUATION_PROVIDER_TRANSLATIONS } from "@/components/vehicle-valuation/vehicle-valuation-provider-translations";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

const VEHICLE_VALUATION_PROVIDER_VALUES = [
  VehicleValuationProvider.Dat,
] as const satisfies readonly VehicleValuationProvider[];

const VEHICLE_VALUATION_PROVIDER_FILTER_OPTIONS: { id: VehicleValuationProvider; name: string }[] =
  VEHICLE_VALUATION_PROVIDER_VALUES.map((provider) => ({
    id: provider,
    name: VEHICLE_VALUATION_PROVIDER_TRANSLATIONS[provider],
  }));

export class VehicleValuationProviderFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id: string = "providers";
  readonly labelSingular = "masterdata:Provider";
  readonly labelPlural = "masterdata:Provider";
  readonly placeholder = "fab:SelectVehicleValuationProvider";
  readonly searchPlaceholder = "fab:SearchVehicleValuationProvider";
  readonly emptyText = "fab:NoVehicleValuationProviderFound";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return {
      options: VEHICLE_VALUATION_PROVIDER_FILTER_OPTIONS,
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
